import React from 'react';
import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { InlineMessage, INLINE_MESSAGE_TYPES } from 'ui-components/components/inline-message';
import { usePickupSettingsContext, usePickupSettingsContextTypes } from '../contexts/pickup-settings-context';

import messages from '../messages';
import style from '../style.module.less';

const pickPackTimeIntervals = ['0:00', '0:15', '0:30', '0:45', '1:00', '1:15', '1:30', '1:45', '2:00'];
const getFormattedMessageForInterval = (interval) => {
  const [hours, minutes] = interval.split(':').map((num) => Number(num));
  return <FormattedMessage {...messages.pickPackHourAndMinutesOption} values={{ hours, minutes }} />;
};
const pickPackOptions = pickPackTimeIntervals.map((interval) => ({
  value: `0${interval}:00`,
  formattedMessage: getFormattedMessageForInterval(interval),
}));
const getSelectedPickPackTimeInterval = (interval) => pickPackOptions.find((option) => option.value === interval);

const PickPackTimeDropdown = () => {
  usePickupSettingsContextTypes('PickPackTimeDropdown');
  const { daySchedule, onSetPickPackTime } = usePickupSettingsContext();
  const selectedPickPackTimeInterval = getSelectedPickPackTimeInterval(
    daySchedule.Monday.pickPackTime !== '00:00:00' ? daySchedule.Monday.pickPackTime : null,
  );
  return (
    <>
      <label className={style.label}>
        <FormattedMessage {...messages.pickAndPackTimeSectionLabel} />
      </label>
      <div className={style['input-section-wrapper']}>
        <DropdownMenu className={style['full-row-dd']} dropdownMenuShouldHaveWidthOfButton variant='form'>
          <DropdownMenuToggler>
            {selectedPickPackTimeInterval ? (
              selectedPickPackTimeInterval.formattedMessage
            ) : (
              <FormattedMessage defaultMessage='Select time' description='select a time default value' id='dDOTrV' />
            )}
          </DropdownMenuToggler>
          {pickPackOptions.map((option) => (
            <DropdownMenuItem key={option.value} name={option.value} onClick={onSetPickPackTime} value={option.value}>
              {option.formattedMessage}
            </DropdownMenuItem>
          ))}
        </DropdownMenu>
        <InlineMessage type={INLINE_MESSAGE_TYPES.sublabel}>
          <FormattedMessage {...messages.pickAndPackTimeHelperLabel} />
        </InlineMessage>
      </div>
    </>
  );
};

export default PickPackTimeDropdown;
